<template>
   <div>
      <v-container>
         <v-row class="pt-5"></v-row>
         <v-form ref="roleform" v-model="roleform_valid">
            <v-row>
               <v-col cols="12" md="12">
                  <v-toolbar dense :color="this.$globalstore.secondary_titleclass" bottom>
                     <v-toolbar-title>Edit Role</v-toolbar-title>
                     <v-spacer></v-spacer>
                     <v-btn color="indigo" class="white ma-2" outlined @click="SaveRole">
                        Save
                     </v-btn>
                     <v-btn color="indigo" class="white ma-2" outlined @click="goBack()">
                        Back
                     </v-btn>
                  </v-toolbar>
               </v-col>
            </v-row>

            <v-row>
               <v-col cols="12" md="6">
                  <v-card flat outlined class="pl-5 pr-10 pb-6">
                     <v-text-field
                        label="Name"
                        v-model="edit_role_name"
                        required
                        :rules="rules_role_name"
                     >
                     </v-text-field>

                     <v-text-field
                        label="Description"
                        v-model="edit_role_description"
                        required
                        :rules="rules_role_description"
                     >
                     </v-text-field>
                  </v-card>
               </v-col>
               <v-col cols="12" md="6">
                  <v-card flat outlined class="pl-5 pr-10">
                     <v-select
                        label="Status"
                        :items="$globalstore.status_select"
                        item-text="text"
                        item-value="id"
                        return-object
                        v-model="edit_role_status"
                        required
                     ></v-select>
                  </v-card>
                  <v-card flat outlined height="95px" class="overflow-y-auto">
                     <v-card-text class="py-1"><b>Assigned Users</b></v-card-text>
                     <v-data-table
                        dense
                        :headers="assigned_header"
                        hide-default-footer
                        hide-default-header
                        :items="assigneduserdata"
                        item-key="user_id"
                     >
                     </v-data-table>
                  </v-card>
               </v-col>
            </v-row>
            <v-row>
               <v-col cols="12" md="5">
                  <v-card flat outlined>
                     <v-card-text class="py-1"><b>Assigned Capabilities</b></v-card-text>
                     <v-data-table
                        v-model="rolecaplist_select"
                        dense
                        :headers="cap_header"
                        :items="rolecaplist"
                        @click:row="caplist_rowClick"
                        item-key="cap_id"
                        sort-by="cap_id"
                        single-select
                     >
                     </v-data-table>
                  </v-card>
               </v-col>
               <v-col cols="12" md="2" class="text-center">
                  <v-card flat class="pa-2 mt-10 mb-4">
                     <v-btn
                        :disabled="capmasterlist.length === 0"
                        outlined
                        color="teal"
                        @click="moveToRole"
                     >
                        <v-icon v-if="!$vuetify.breakpoint.mdAndUp">mdi-arrow-up-bold</v-icon>
                        <v-icon v-else>mdi-arrow-left-bold</v-icon>
                     </v-btn>

                     <v-btn
                        :disabled="rolecaplist.length === 0"
                        outlined
                        color="orange"
                        class="pa-2 my-4"
                        @click="moveFromRole"
                     >
                        <v-icon v-if="!$vuetify.breakpoint.mdAndUp">mdi-arrow-down-bold</v-icon>
                        <v-icon v-else>mdi-arrow-right-bold</v-icon>
                     </v-btn>
                  </v-card>
               </v-col>
               <v-col cols="12" md="5">
                  <v-card flat outlined>
                     <v-card-text class="py-1"><b>Available Capabilities</b></v-card-text>
                     <v-data-table
                        v-model="capmaster_select"
                        dense
                        :headers="capmaster_header"
                        :items="capmasterlist"
                        @click:row="capmasterlist_rowClick"
                        sort-by="cap_id"
                        item-key="cap_id"
                        single-select
                     >
                     </v-data-table>
                  </v-card>
               </v-col>
            </v-row>
         </v-form>
      </v-container>
      <show-toast ref="toast"></show-toast>
   </div>
</template>

<script>
   import GlobalConstant from "../common/globalconstant.js";
   import showToast from "../components/showToast.vue";
   export default {
      components: {showToast},

      inject: ["ShowMessage"],

      data() {
         return {
            capmaster_range: GlobalConstant.CAPMASTER_RANGE,
            edit_role_id: -1,
            edit_role_name: "",
            edit_role_description: "",
            edit_role_status: 1,
            roleform_valid: true,
            rules_role_name: [(v) => !!v || "Name is required"],
            rules_role_description: [(v) => !!v || "Description is required"],

            cap_header: [
               {
                  text: "Cap ID",
                  value: "cap_id",
                  class: this.$globalstore.table_headerclass,
               },
               {
                  text: "Name",
                  value: "cap_name",
                  class: this.$globalstore.table_headerclass,
               },
            ],
            rolecaplist: [],
            capmaster_header: [
               {
                  text: "Cap ID",
                  value: "cap_id",
                  class: this.$globalstore.table_headerclass,
               },
               {
                  text: "Name",
                  value: "cap_name",
                  class: this.$globalstore.table_headerclass,
               },
            ],
            capmasterlist: [],
            rolecaplist_select: [],
            capmaster_select: [],
            assigneduserdata: [],
            assigned_header: [{text: "Name", value: "user_name"}],
         };
      },
      methods: {
         goBack() {
            this.$router.go(-1);
         },

         async SaveRole() {
            if (!this.$refs.roleform.validate()) {
               this.ShowMessage({
                  title: "Error",
                  message: "Please complete the form.",
                  color: "red",
               });
            } else {
               await this.$http({
                  url: "/common/updaterole.php",
                  headers: {
                     "Content-Type": "application/x-www-form-urlencoded",
                  },
                  data: {
                     id: this.edit_role_id,
                     role_name: this.edit_role_name,
                     role_description: this.edit_role_description,
                     role_status: this.edit_role_status.id,
                     userid: this.$globalstore.user.userid,
                  },
                  method: "POST",
               }).then((response) => {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.goBack();
                  }
               });
            }
         },

         async moveToRole() {
            if (this.capmaster_select && this.capmaster_select[0]) {
               let item = this.capmaster_select[0];
               if (!this.rolecaplist.some((x) => x.cap_id == item.cap_id)) {
                  await this.$http({
                     url: "/common/addcaptorole.php",
                     headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                     },
                     data: {
                        role_id: this.edit_role_id,
                        cap_id: item.cap_id,
                        userid: this.$globalstore.user.userid,
                     },
                     method: "POST",
                  }).then((response) => {
                     if (!response.data.error) {
                        this.rolecaplist.push(item);
                        let index = this.capmasterlist.findIndex((x) => x.cap_id == item.cap_id);
                        this.capmasterlist.splice(index, 1);
                        this.capmaster_select = [];
                        this.$refs.toast.display({
                           message: "Capability added to role.",
                           color: this.$globalstore.toast_successclass,
                        });
                     }
                  });
               }
            }
         },

         async moveFromRole(item) {
            if (this.rolecaplist_select) {
               let item = this.rolecaplist_select[0];

               if (!this.capmasterlist.some((x) => x.cap_id == item.cap_id)) {
                  await this.$http({
                     url: "/common/removecapfromrole.php",
                     headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                     },
                     data: {
                        role_id: this.edit_role_id,
                        cap_id: item.cap_id,
                        userid: this.$globalstore.user.userid,
                     },
                     method: "POST",
                  }).then((response) => {
                     if (!response.data.error) {
                        this.capmasterlist.push(item);
                        let index = this.rolecaplist.findIndex((x) => x.cap_id == item.cap_id);
                        this.rolecaplist.splice(index, 1);
                        this.rolecaplist_select = [];
                        this.$refs.toast.display({
                           message: "Capability removed from role.",
                           color: this.$globalstore.toast_successclass,
                        });
                     }
                  });
               }
            }
         },

         async getRoleByID() {
            await this.$http({
               url: "/common/getrole_byid.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  role_id: this.edit_role_id,
                  range: this.capmaster_range,
               },
               method: "POST",
            }).then((response) => {
               if (!response.data.error) {
                  this.edit_role_name = response.data.roledata.role_name;
                  this.edit_role_description = response.data.roledata.role_description;
                  this.edit_role_status = this.$globalstore.status_select.find(
                     (item) => item.id === response.data.roledata.role_status
                  );
                  this.rolecaplist = response.data.roledata.rolecaplist;
               } else {
                  this.ShowMessage({
                     title: "Error",
                     message: response.data.message,
                     color: "red",
                  });
               }
            });
         },

         async getCapMasterList() {
            await this.$http({
               url: "/common/getcapmasterlist.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  range: this.capmaster_range,
                  userid: this.$globalstore.user.userid,
                  usertoken: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (!response.data.error) {
                  this.capmasterlist = response.data.capmasterlist.filter((item) => {
                     return !this.rolecaplist.some((x) => x.cap_id == item.cap_id);
                  });
               } else {
                  this.ShowMessage({
                     title: "Error",
                     message: response.data.message,
                     color: "red",
                  });
               }
            });
         },

         async getAssignedList() {
            await this.$http({
               url: "/common/getroleassignment.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  role_id: this.edit_role_id,
               },
               method: "POST",
            }).then((response) => {
               if (!response.data.error) {
                  this.assigneduserdata = response.data.assigneduser;
               }
            });
         },

         caplist_rowClick(item, row) {
            row.select(true);
         },

         capmasterlist_rowClick(item, row) {
            row.select(true);
         },
      },

      async mounted() {
         if (this.$route.params.role_id) {
            this.edit_role_id = this.$route.params.role_id;
            await this.getRoleByID();
            await this.getCapMasterList();
            await this.getAssignedList();
         }
      },
   };
</script>
